export default __webpack_public_path__ + "content/media/IcoInstagram.b7541f09.svg";